module.exports = __webpack_public_path__ + "img/中通商业.521fe0e0.png";